import styled from '@emotion/styled';
import type { Property } from 'csstype';
import type { DropdownIndicatorProps, GroupBase, Props } from 'react-select';
import Select from 'react-select';

import Arrow from '../../assets/icons/svg/arrowDropdown.svg';
import type { SkeletonSize } from '../skeleton/Skeleton';
import { themeVars } from '../theme/theme';

type selectSize = 'small' | 'medium' | 'large';

const sizeSchema: Record<SkeletonSize, string> = {
  small: '32px',
  medium: '40px',
  large: '56px',
};

export const FrontSelect = <
  Option,
  IsMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>,
>({
  width,
  minWidth,
  size = 'medium',
  ...rest
}: Props<Option, IsMulti, Group> & {
  width?: Property.Width;
  minWidth?: Property.Width;
  size?: selectSize;
}) => {
  return (
    <Wrapper $width={width} $minWidth={minWidth} $size={size}>
      <Select
        menuPortalTarget={document.body}
        {...rest}
        classNamePrefix={'Select'}
        components={{ DropdownIndicator, ...rest?.components }}
        styles={{
          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
          ...rest.styles,
        }}
      />
    </Wrapper>
  );
};

const DropdownIndicator = <Option, IsMulti extends boolean = false>(
  props: DropdownIndicatorProps<Option, IsMulti, GroupBase<Option>>,
) => {
  return (
    <div {...props.innerProps}>
      <ArrowIcon />
    </div>
  );
};

const Wrapper = styled.div<{
  $width?: Property.Width;
  $minWidth?: Property.Width;
  $size?: selectSize;
}>`
  & .Select__control {
    width: ${({ $width }) => $width || '100%'};
    min-width: ${({ $minWidth }) => $minWidth || '100%'};
    border-radius: 8px;
    border: 1px solid #b8c3c8;
    color: #000;
    font-weight: 400;
    font-size: 16px;
    letter-spacing: 0;

    line-height: 16px;
    height: ${({ $size }) => sizeSchema[$size || 'medium']};
    display: flex;
    flex-wrap: nowrap;
    overflow: hidden;
    font-family: ${themeVars.fonts.telka};
  }

  & .Select__indicator-separator {
    display: none;
  }

  & .Select__single-value {
    color: #000;
    font-size: 16px;
    font-weight: 400;
  }
`;

const ArrowIcon = styled('div')`
  width: 20px;
  height: 20px;
  mask: url(${Arrow}) no-repeat center / contain;
  background-color: #65665e;
  cursor: pointer;
  margin-right: 8px;

  &:hover {
    background-color: #2a2e28;
  }
`;
